// Keep in sync with package.json during releases.
// Prefer importing the package's package.json for the canonical version when possible.
export const VERSION = "2.0.3";
